"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _reactIcons = require("@100mslive/react-icons");
var _PIPManager = require("./PIPManager");
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _constants = require("../../common/constants");
var _SetupMediaSession = require("./SetupMediaSession");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * shows a button which when clicked shows some videos in PIP, clicking
 * again turns it off.
 */
var PIPComponent = function PIPComponent() {
  var localPeerRole = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerRoleName);
  var _useState = (0, _react.useState)(_PIPManager.PictureInPicture.isOn()),
    _useState2 = _slicedToArray(_useState, 2),
    isPipOn = _useState2[0],
    setIsPipOn = _useState2[1];
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var store = (0, _reactSdk.useHMSVanillaStore)();
  var onPipToggle = (0, _react.useCallback)(function () {
    if (!isPipOn) {
      _PIPManager.PictureInPicture.start(hmsActions, setIsPipOn)["catch"](function (err) {
        return console.error("error in starting pip", err);
      });
      _SetupMediaSession.MediaSession.setup(hmsActions, store);
    } else {
      _PIPManager.PictureInPicture.stop()["catch"](function (err) {
        return console.error("error in stopping pip", err);
      });
    }
  }, [hmsActions, isPipOn, store]);

  // stop pip on unmount
  (0, _react.useEffect)(function () {
    return function () {
      _PIPManager.PictureInPicture.stop()["catch"](function (err) {
        return console.error("error in stopping pip on unmount", err);
      });
    };
  }, []);
  if (!_PIPManager.PictureInPicture.isSupported() || localPeerRole === _constants.DEFAULT_HLS_VIEWER_ROLE) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
      title: "".concat(isPipOn ? "Deactivate" : "Activate", " picture in picture view"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        active: !isPipOn,
        onClick: function onClick() {
          return onPipToggle();
        },
        "data-testid": "pip_btn",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PipIcon, {})
      }, "pip")
    }), isPipOn && /*#__PURE__*/(0, _jsxRuntime.jsx)(ActivatedPIP, {
      setIsPipOn: setIsPipOn
    })]
  });
};

/**
 * this is a separate component so it can be conditionally rendered and
 * the subscriptions to store are done only if required.
 */
var ActivatedPIP = function ActivatedPIP() {
  var tracksMap = (0, _reactSdk.useHMSStore)(_reactSdk.selectTracksMap);
  var remotePeers = (0, _reactSdk.useHMSStore)(_reactSdk.selectRemotePeers);
  (0, _react.useEffect)(function () {
    _PIPManager.PictureInPicture.updatePeersAndTracks(remotePeers, tracksMap)["catch"](function (err) {
      console.error("error in updating pip", err);
    });
  }, [tracksMap, remotePeers]);
  return null;
};
var _default = PIPComponent;
exports["default"] = _default;